import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import axiosConfig from "../axiosConfig";

export default (WrappedComponent) => {
  return class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        isAuthorized: null,
      };
    }

    componentDidMount() {
      try {
        const brand_id = sessionStorage.getItem("brand_id");
        axiosConfig
          .get(`/brand/${brand_id}`)
          .then((response) => {
            // console.log(response.data.is_subscribed);
            this.setState({ isAuthorized: response.data.is_subscribed });
          })
          .catch((err) => {
            // console.log(err);
            // console.log(err.response);
            alert("Unexpected Error");
          });
      } catch (err) {
        // console.log(err);
        // console.log(err.response);
      }
    }

    render() {
      const { isAuthorized } = this.state;
      return (
        <div>
          {isAuthorized ? (
            <WrappedComponent />
          ) : isAuthorized === false ? (
            <Redirect to={{ pathname: "/company/subscription" }} />
          ) : null}
        </div>
      );
    }
  };
};
